import React from "react";
import blackLogo from "assests/black-logo.png";
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <Link className="py-2" to={"/"}>
      <img className="w-40" src={blackLogo} alt="" />
    </Link>
  );
};

export default Logo;
